import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import {
  ColumnIcon,
  FilterDropdownProps,
  FilterTypeEnum,
  SaveFiltersSorterEnum,
  SearchFilter,
  ShowBreadCrumbsEnum,
  stringCompare,
  TableSettings,
} from '@vcd-ecm-ui/GenericGrid';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Contact Name',
    dataIndex: 'name',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.name, b.rowData.name),
    ellipsis: true,
    render: (value, row: GridRowData, index: number) => (row.rowData.primaryInd
      ? <ColumnIcon id="name" icon="star" iconPlacement="right" value={value} iconSize={14} />
      : value
    ),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Contact Name" dataIndex="name" props={props} />,
  },
  {
    title: 'Department',
    dataIndex: 'department',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.department, b.rowData.department),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Department" dataIndex="department" props={props} />,
  },
  {
    title: 'E-Mail',
    dataIndex: 'email',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.email, b.rowData.email),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="E-Mail" dataIndex="email" props={props} />,
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.phone, b.rowData.phone),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Phone" dataIndex="phone" props={props} />,
  },
  {
    title: 'Extension',
    dataIndex: 'phoneExtension',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.phoneExtension, b.rowData.phoneExtension),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Extension" dataIndex="phoneExtension" props={props} />,
  },
  {
    title: 'Fax',
    dataIndex: 'fax',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.fax, b.rowData.fax),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Fax" dataIndex="fax" props={props} />,
  },
  {
    title: 'Street Address',
    dataIndex: 'address',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.address, b.rowData.address),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Street Address" dataIndex="address" props={props} />,
  },
  {
    title: 'Street Address 2',
    dataIndex: 'address2',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.address2, b.rowData.address2),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Street Address 2" dataIndex="address2" props={props} />,
  },
  {
    title: 'City',
    dataIndex: 'city',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.city, b.rowData.city),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="City" dataIndex="city" props={props} />,
  },
  {
    title: 'State / Province',
    dataIndex: 'state',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.state, b.state),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="State / Provincee" dataIndex="state" props={props} />,
  },
  {
    title: 'Postal / Zip',
    dataIndex: 'postalCode',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.postalCode, b.rowData.postalCode),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Postal / Zip" dataIndex="postalCode" props={props} />,
  },
  {
    title: 'Country',
    dataIndex: 'country',
    className: 'contactsColumnStyle',
    // sorter: true,
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.country, b.country),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={FilterTypeEnum.Text} title="Country" dataIndex="country" props={props} />,
  },
];

// Additional Table Settings - Will add the the Table Settings extracted from Columns
export const additionalTableSettings: TableSettings = {
  version: 'v1',
  hideDisabledColumns: false,
  saveFiltersSorter: SaveFiltersSorterEnum.NEVER,
  showBreadcrumbs: ShowBreadCrumbsEnum.NEVER,
  columns: [
    {
      dataIndex: 'action',
      canChangePin: false,
      canMove: false,
      canChangeVisibilty: false,
    },
  ],
};

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
